/* jshint esversion: 6 */
/**
 * @module helperTemplates
 */
const helperTemplates = function(app) {
  
  const get = function(selector) {
    return $($(selector).html());
  };
  
  return {
    get
  };
};

export default helperTemplates;
